/** Hand-synced value mirror of the API catalogue — the web bundler can't value-import workspace TS. */
export const PERMISSIONS = {
  // Tests / assessments
  TESTS_LIST: 'TESTS_LIST',
  TESTS_VIEW: 'TESTS_VIEW',
  TESTS_CREATE: 'TESTS_CREATE',
  TESTS_EDIT: 'TESTS_EDIT',
  TESTS_DELETE: 'TESTS_DELETE',
  TESTS_VIEW_RESULTS: 'TESTS_VIEW_RESULTS',
  // Question bank
  QUESTIONS_LIST: 'QUESTIONS_LIST',
  QUESTIONS_VIEW: 'QUESTIONS_VIEW',
  QUESTIONS_CREATE: 'QUESTIONS_CREATE',
  QUESTIONS_EDIT: 'QUESTIONS_EDIT',
  QUESTIONS_DELETE: 'QUESTIONS_DELETE',
  // Subjects
  SUBJECTS_LIST: 'SUBJECTS_LIST',
  SUBJECTS_VIEW: 'SUBJECTS_VIEW',
  SUBJECTS_CREATE: 'SUBJECTS_CREATE',
  SUBJECTS_EDIT: 'SUBJECTS_EDIT',
  SUBJECTS_DELETE: 'SUBJECTS_DELETE',
  // Collections
  COLLECTIONS_LIST: 'COLLECTIONS_LIST',
  COLLECTIONS_VIEW: 'COLLECTIONS_VIEW',
  COLLECTIONS_CREATE: 'COLLECTIONS_CREATE',
  COLLECTIONS_EDIT: 'COLLECTIONS_EDIT',
  COLLECTIONS_DELETE: 'COLLECTIONS_DELETE',
  // Teams
  TEAMS_LIST: 'TEAMS_LIST',
  TEAMS_VIEW: 'TEAMS_VIEW',
  TEAMS_CREATE: 'TEAMS_CREATE',
  TEAMS_EDIT: 'TEAMS_EDIT',
  TEAMS_DELETE: 'TEAMS_DELETE',
  TEAMS_MANAGE_MEMBERS: 'TEAMS_MANAGE_MEMBERS',
  TEAMS_INVITE: 'TEAMS_INVITE',
  TEAMS_ACTIVITY: 'TEAMS_ACTIVITY',
  // Members / staff
  MEMBERS_LIST: 'MEMBERS_LIST',
  MEMBERS_VIEW: 'MEMBERS_VIEW',
  MEMBERS_EDIT: 'MEMBERS_EDIT',
  MEMBERS_INVITE: 'MEMBERS_INVITE',
  MEMBERS_REMOVE: 'MEMBERS_REMOVE',
  // Roles & permissions
  ROLES_VIEW: 'ROLES_VIEW',
  ROLES_EDIT: 'ROLES_EDIT',
  // Access keys / invite codes
  ACCESS_KEYS_LIST: 'ACCESS_KEYS_LIST',
  ACCESS_KEYS_CREATE: 'ACCESS_KEYS_CREATE',
  ACCESS_KEYS_DELETE: 'ACCESS_KEYS_DELETE',
  // Live monitoring
  MONITORING_MONITOR: 'MONITORING_MONITOR',
  // Grading
  GRADING_VIEW: 'GRADING_VIEW',
  GRADING_GRADE: 'GRADING_GRADE',
  GRADING_EXPORT: 'GRADING_EXPORT',
  // Results
  RESULTS_VIEW: 'RESULTS_VIEW',
  RESULTS_EXPORT: 'RESULTS_EXPORT',
  // Documents (private authoring resource — no list/view tier; gated on edit)
  DOCUMENTS_EDIT: 'DOCUMENTS_EDIT',
  DOCUMENTS_DELETE: 'DOCUMENTS_DELETE',
  // AI learning
  AI_LEARNING_VIEW: 'AI_LEARNING_VIEW',
  // Billing
  BILLING_VIEW: 'BILLING_VIEW',
  BILLING_EDIT: 'BILLING_EDIT',
} as const;

export type Permission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];
